import { errorServeiceHandler } from "./helper";

export const actGetUserInfo = (context, payload) => {
  return new Promise((resolve, reject) => {
    fetch(context.state.baseUrl + "/subscriber/v1/subscriber")
      .then(errorServeiceHandler)
      .then(response => {
        return response.json();
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
};



// WEBPACK FOOTER //
// ./src/store/actions.js